<template>
	<PopupRouterView :showLeftIcon="true" label="Part Purchase Quality Control Input" okTitle="Save"
		cancelTitle="Cancel" entityName="partpurchasequalitycontrol" :documentId="mainRecordId" @saveMethod="saveAction"
		@hideMethod="onHidden" ref="partPurchaseQualityControlInput" modalClass="input-scan-page">

		<template #modal-header-left-button>
			<span class="mr-1 d-sm-flex d-md-none">
				<b-button size="sm" class="ml-1 btn-back " @click="$router.back()"><b-icon-arrow-left /></b-button>
			</span>
		</template>

		<div class="p-2">
			<span v-if="scanPageIndex == 1">
				<b-row>
					<b-col cols="12">
						<app-input-datepicker id="fieldset-part-purchase-quality-control-date" label-cols-lg="12"
							label="Quality Control Date" size="sm" :model.sync="model.partPurchaseQualityControlDate"
							:isRequired="true" :state="validateState('partPurchaseQualityControlDate')"
							:errorMessage="getErrorMessage(errorMessage.partPurchaseQualityControlDate, 'partPurchaseQualityControlDate')"
							:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
							@change="updateData" />
						<app-input-textarea id="fieldset-description" ref="fieldset-description" label-cols-lg="12" label="Description"
							label-for="input-description" size="sm" :model.sync="model.description"
							@change="updateData" />

					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 2">
				<b-row>
					<b-col cols="12">
						<app-label
							v-if="parentValueInfo != undefined && parentValueInfo != null && parentValueInfo != ''"
							label-cols-lg="12" size="sm" :label="parentLabelInfo" :model="parentValueInfo" />
						<app-input-scan id="fieldset-control-card" ref="fieldset-control-card"
							:model.sync="controlCardQrCode" label="MCC" @scannedMethod="scanControlCard"
							:isBusy="isScanControlCardLoading" autofocus @focus.once="getControlCards()" />
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<span v-if="controlCards != null && controlCards.length > 0">
							<app-list :isDataLoading="isControlCardControlCardsLoading" :dataCount="controlCards.length">
								<part-purchase-quality-control-detail-item v-for="(item,index) in controlCards" :model="item" :key="index" @nextAction="goToNext(1, item)" :isDisabled="checkIsControlCardDisabled(item)"/>
							</app-list>
						</span>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<span
							v-if="partPurchaseQualityControlDetailsFiltered != null && partPurchaseQualityControlDetailsFiltered.length > 0">
							<b-table :class="'table-action table-index'" head-variant="head-light" :bordered="true"
								:items="partPurchaseQualityControlDetailsFiltered"
								:fields="fieldsPartPurchaseQualityControlDetail" :busy="isDataLoading"
								:sort-by.sync="sortByPartPurchaseQualityControlDetail"
								:sort-desc.sync="sortDescPartPurchaseQualityControlDetail" small responsive
								:showActionButton="false" :showDeleteButton="false" :showAddButton="false"
								:showAddFromClipboardButton="false" :showReplaceFromClipboardButton="false"
								:showUploadButton="false" :showDownloadButton="false"
								:isDownloadBusy="isDownloadPartPurchaseQualityControlDetail" >
							
								<template v-slot:cell(controlCard)="row">
									<a @click="goToNext(3, row.item)"
										class="a-link-detail">
										{{ row.item.controlCard != null && row.item.controlCard != "" ? row.item.controlCard.controlCardNumber : "..." }}
									</a>
								</template>
							</b-table>
						</span>


					</b-col>
				</b-row>
			</span>

		</div>


		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-action-button>
			<b-button v-if="scanPageIndex == 1" size="sm" class="btn-fill-success float-right"
				@click="goToNext(2)">Next</b-button>
			<b-button v-if="scanPageIndex == 2" size="sm" class="btn-fill-success float-right" @click="goToNext(1)">Back</b-button>
			<b-button
				v-if="scanPageIndex == 2 && partPurchaseQualityControlDetailsFiltered != null && partPurchaseQualityControlDetailsFiltered.length > 0"
				size="sm" class="btn-fill-success float-right" @click="saveAction()">Finish</b-button>

		</template>
		<PartPurchaseQualityControlDetailScan :parentLabelInfo="parentLabelInfo" :parentValueInfo="parentValueInfo"
			:model="modelPartPurchaseQualityControlDetail" :modelId="partPurchaseQualityControlDetailId"
			:openPopup="isShowPopupPartPurchaseQualityControlDetail" :isShowInput="isShowInput"
			@resetMethod="resetModal" @addButtonMethod="addRowDataPartPurchaseQualityControlDetail" />

	</PopupRouterView>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import toast from '@/mixins/toastMixin';
import focusInput from '@/mixins/focusInputMixin';
import AppInputScan from '@/components/AppInputScan';
import AppList from '@/components/AppList';
import PartPurchaseQualityControl from '@/models/PartPurchaseQualityControl/PartPurchaseQualityControl';
import PartPurchaseQualityControlList from '@/models/PartPurchaseQualityControl/PartPurchaseQualityControlList';
import PartPurchaseQualityControlFilter from '@/filters/PartPurchaseQualityControl/PartPurchaseQualityControlFilter';
import PartPurchaseQualityControlDetailItem from './components/PartPurchaseQualityControlDetailItem';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PartPurchaseQualityControlDetail from '@/models/PartPurchaseQualityControl/PartPurchaseQualityControlDetail';
import PartPurchaseQualityControlDetailFilter from '@/filters/PartPurchaseQualityControl/PartPurchaseQualityControlDetailFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputCheckbox from '@/components/AppInputCheckbox';
import ControlCardStatus from '@/models/ControlCardStatus/ControlCardStatus';
import ControlCardStatusFilter from '@/filters/ControlCardStatus/ControlCardStatusFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import PartPurchaseQualityControlDetailInput from '@/views/PartPurchaseQualityControl/PartPurchaseQualityControlDetailInput';
import PartPurchaseQualityControlDetailScan from '@/views/PartPurchaseQualityControl/PartPurchaseQualityControlDetailScan';
import PartPurchaseQualityControlDetailUpload from '@/views/PartPurchaseQualityControl/PartPurchaseQualityControlDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
import PartClassification from '@/models/PartClassification/PartClassification';
import PartClassificationFilter from '@/filters/PartClassification/PartClassificationFilter';

export default {
	components: {
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputCheckbox,
		PartPurchaseQualityControlDetailInput,
		PartPurchaseQualityControlDetailScan,
		PartPurchaseQualityControlDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
		AppInputScan,
		AppList,
		PartPurchaseQualityControlDetailItem,
	},
	mixins: [validationMixin, toast, focusInput],
	validations: {
		model: {
			partPurchaseQualityControlDate: { required },
		},
	},
	data() {
		return {
			errorMessage: {
				partPurchaseQualityControlDate: { required: "Quality Control Date is Required." },
			},
			datas: Array(),
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions: [
				{ value: '10', text: '10', selected: true },
				{ value: '25', text: '25' },
				{ value: '50', text: '50' },
				{ value: '100', text: '100' },
			],
			fieldsPartPurchaseQualityControlDetail: [
				// {"frontActions": { "class" : "th-actions", "label" : ""}},
				// {"no" : { "class" : "th-number d-stack-none"}}, 
				{ "controlCard": { "class": "th-control-card first-child", "label": "MCC", key: 'controlCard', sortable: false } },
				// {"thickness": { "class" : "th-thickness", "label" : "Thickness", key: 'thickness', sortable: false}}, 
				// {"width": { "class" : "th-width last-child", "label" : "Width", key: 'width', sortable: false}}, 
				// {"length": { "class" : "th-length d-stack-none", "label" : "Length", key: 'length', sortable: false}}, 
				{ "qty": { "class": "th-qty d-stack-none", "label": "Qty", key: 'qty', sortable: false } },
				// {"karat": { "class" : "th-karat d-stack-none", "label" : "Karat", key: 'karat', sortable: false}}, 
				// {"retak": { "class" : "th-retak d-stack-none", "label" : "Retak", key: 'retak', sortable: false}}, 
				// {"goresan": { "class" : "th-goresan d-stack-none", "label" : "Goresan", key: 'goresan', sortable: false}}, 
				// {"gelombang": { "class" : "th-gelombang d-stack-none", "label" : "Gelombang", key: 'gelombang', sortable: false}}, 
				// {"burry": { "class" : "th-burry d-stack-none", "label" : "Burry", key: 'burry', sortable: false}}, 
				// {"benjolan": { "class" : "th-benjolan d-stack-none", "label" : "Benjolan", key: 'benjolan', sortable: false}}, 
				// {"otherProblem": { "class" : "th-other-problem d-stack-none", "label" : "Other Problem", key: 'otherProblem', sortable: false}}, 
				// {"ngInformation": { "class" : "th-ng-information d-stack-none", "label" : "Ng Information", key: 'ngInformation', sortable: false}}, 
				{ "controlCardStatus": { "class": "th-control-card-status d-stack-none", "label": "Control Card Status", key: 'controlCardStatus.name', sortable: false } },
				// {"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy: false,
			isBusy: false,
			isDataLoading: false,
			selected: '',
			pageSizeOptions: 10,
			pageIndex: 0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelPartPurchaseQualityControlDetail: {},
			isShowPopupPartPurchaseQualityControlDetail: false,
			isShowPopupUploadPartPurchaseQualityControlDetail: false,
			isShowPopupPartPurchaseQualityControlDetailScan: false,
			filterPartPurchaseQualityControl: null,
			currentPartPurchaseQualityControlPage: 1,
			partPurchaseQualityControlPageSize: 10,
			sortByPartPurchaseQualityControl: '',
			sortDescPartPurchaseQualityControl: '',
			filterPartPurchaseQualityControlDetail: null,
			currentPartPurchaseQualityControlDetailPage: 1,
			partPurchaseQualityControlDetailPageSize: 10,
			sortByPartPurchaseQualityControlDetail: '',
			sortDescPartPurchaseQualityControlDetail: '',
			sortingByPartPurchaseQualityControlDetail: [],
			partPurchaseQualityControlDetails: [],
			partPurchaseQualityControlDetailId: '',
			totalPartPurchaseQualityControlDetailRow: 0,
			isShowPartPurchaseQualityControlDetailFilter: false,
			isDownloadPartPurchaseQualityControlDetail: false,
			controlCards: [],
			controlCardStatuss: [],
			partClassifications: [],
			isShowPopupConfirmation: false,
			isDataCommited: false,
			mainRecordId: '',
			isControlCardComboLoading: false,
			isPartPurchaseQualityControlComboLoading: false,
			isControlCardStatusComboLoading: false,
			scanPageIndex: 1,
			parentLabelInfo: '',
			parentValueInfo: '',
			controlCardQrCode: '',
			isScanControlCardLoading: false,
			isControlCardControlCardsLoading: false,
			controlCardControlCards: [],
			partPurchaseQualityControlDetailsFiltered: [],
			isScannedControlCard: false,
			isShowInput: false,
			isStacked: false,
		}
	},
	methods: {
		getPartPurchaseQualityControl: async function (id) {
			this.isBusy = true;
			await PartPurchaseQualityControl.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadPartPurchaseQualityControl = true;
			this.filterPartPurchaseQualityControl.id = this.modelId;
			PartPurchaseQualityControl.downloadDataDetail(this, this.filterPartPurchaseQualityControl).then(result => {
				this.isDownloadPartPurchaseQualityControl = false;
			}).catch(error => { this.isDownloadPartPurchaseQualityControl = false; })
		},
		getPartPurchaseQualityControlDetails: async function (isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterPartPurchaseQualityControlDetail);
			if (this.modelId == null) return;
			filter.partPurchaseQualityControlId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByPartPurchaseQualityControlDetail != null) {
				this.sortingByPartPurchaseQualityControlDetail[this.sortByPartPurchaseQualityControlDetail] = this.sortDescPartPurchaseQualityControlDetail;
			}
			let currentPage = (this.currentPartPurchaseQualityControlDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalPartPurchaseQualityControlDetailRow + 1;
				let page = Math.ceil(totalData / this.partPurchaseQualityControlDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.partPurchaseQualityControlDetailPageSize = 0;
			// disable paging end
			PartPurchaseQualityControlDetail.getList(this, filter, this.sortingByPartPurchaseQualityControlDetail, currentPage, this.partPurchaseQualityControlDetailPageSize).then(result => {
				this.currentPartPurchaseQualityControlDetailPage = currentPage + 1;
				this.partPurchaseQualityControlDetails = result.data.filter(obj =>
					Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == false || obj.isScanned == null || obj.isScanned == undefined)
				);
				this.partPurchaseQualityControlDetailsFiltered = result.data.filter(obj =>
					Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == true)
				);
				this.totalPartPurchaseQualityControlDetailRow = result.dataCount;
			}).catch(error => { });
		},
		getPartPurchaseQualityControls: async function (input) {
			let filter = new PartPurchaseQualityControlFilter();
			if (input != undefined) {
				filter.PartPurchaseQualityControlDate = input;
			}
			this.isPartPurchaseQualityControlComboLoading = true;
			await PartPurchaseQualityControl.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.partPurchaseQualityControls = result.data
					}
					this.isPartPurchaseQualityControlComboLoading = false;
				})
				.catch(error => { });
		},
		getControlCards: async function (input) {
			// let filter = new ControlCardFilter();
			// filter.controlCardNumber = input;
			// filter.controlCardStatusId = "OK";
			// filter.areaCode = "TRANSIT INCOMING";
			// this.isControlCardComboLoading = true;
			// await ControlCard.getList(this, filter, null, 0, 10)
			// .then(result => {
			// 	if (result != null) {
			// 		this.controlCards = result.data
			// 	}
			// })
			// .catch(error => { });
			let this_ = this;
			let dataRequest = input !== undefined && input !== null ? input : '';
			await this_.$http.post('PartPurchaseQualityControl/getListControlCard', dataRequest)
			.then(async function (response) {
				if (response.data) {
					this_.controlCards = response.data.data;
				}else{
					this_.controlCards = response;
				}
			})
			.catch(error => {
				if (error.response && error.response.data && error.response.data.errors) {
					const errors = error.response.data.errors;
					// Iterasi melalui setiap pesan kesalahan
					Object.keys(errors).forEach(key => {
						const errorMessages = errors[key];
						errorMessages.forEach(errorMessage => {
							// Tampilkan pesan kesalahan dalam toast
							this_.toast({message: errorMessage, title: 'Error', variant: 'danger', autoHideDelay: 99999});
						});
					});
				}
				this_.controlCards = [];
				this_.controlCardQrCode = '';
				return;
			});
		},
		getControlCardsEqual : async function(input) {
			// this.controlCards = [];
			// let filter = new ControlCardFilter();
			// filter.controlCardNumber = input;
			// filter.exactType.controlCardNumber = 1;
			// filter.controlCardStatusId = "OK";
			// filter.areaCode = "TRANSIT INCOMING";
			// await ControlCard.getList(this, filter, null, 0, 10)
			// .then(result => {
			// 	if (result != null) {
			// 		this.controlCards = result.data
			// 	}
			// })
			// .catch(error => {});
			let this_ = this;
			let dataRequest = input !== undefined && input !== null ? input : '';
			await this_.$http.post('PartPurchaseQualityControl/getListControlCardEqual', dataRequest)
			.then(async function (response) {
				if (response.data) {
					this_.controlCards = response.data.data;
				}else{
					this_.controlCards = response;
				}
			})
			.catch( error => {
				if (error.response && error.response.data && error.response.data.errors) {
					const errors = error.response.data.errors;
					// Iterasi melalui setiap pesan kesalahan
					Object.keys(errors).forEach(key => {
						const errorMessages = errors[key];
						errorMessages.forEach(errorMessage => {
							// Tampilkan pesan kesalahan dalam toast
							this_.toast({message: errorMessage, title: 'Error', variant: 'danger', autoHideDelay: 99999});
						});
					});
				}
				this_.controlCards = [];
				this_.controlCardQrCode = '';
				return;
			});
		},
		getPartPurchaseQualityControls: async function (input) {
			let filter = new PartPurchaseQualityControlFilter();
			if (input != undefined) {
				filter.partPurchaseQualityControlDate = input;
			}
			this.isPartPurchaseQualityControlComboLoading = true;
			await PartPurchaseQualityControl.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.partPurchaseQualityControls = result.data
					}
					this.isPartPurchaseQualityControlComboLoading = false;
				})
				.catch(error => { });
		},
		getControlCardStatuss: async function (input) {
			let filter = new ControlCardStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isControlCardStatusComboLoading = true;
			await ControlCardStatus.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.controlCardStatuss = result.data
					}
					this.isControlCardStatusComboLoading = false;
				})
				.catch(error => { });
		},
		getPartClassification: async function (input) {
			let filter = new PartClassificationFilter();
			if (input != undefined) {
				filter.name = input;
			}
			PartClassification.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.partClassifications = result.data
					}
				})
				.catch(error => { });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.partPurchaseQualityControlInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			if (modalEvent != undefined && modalEvent != null) {
				modalEvent.preventDefault();
			}
			let id = this.$route.params.id;
			this.$v.model.$touch();
			if (this.partPurchaseQualityControlDetailsFiltered.length == 0) return;
			if (this.$v.model.$anyError) {
				return;
			} else {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Apakah anda yakin akan menyelesaikan proses QC dan melakukan request approval atas dokumen QC ?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e => {
					if (e) {
						this.isBusy = true;
						let id = this.modelId;
						let model = this.model;

						if (id != '' && id != null && id != undefined) {
							PartPurchaseQualityControl.commitData(this, model, id).then(result => {
								this.isDataCommited = true;
								this.$router.push({ name: 'partpurchasequalitycontrolindex' });
								this.isBusy = false;
							}).catch(error => { this.isBusy = false; });
						} else {
							PartPurchaseQualityControl.insertData(this, model).then(result => {
								this.isDataCommited = true;
								this.$router.push({ name: 'partpurchasequalitycontrolindex' });
								this.isBusy = false;
							}).catch(error => { this.isBusy = false; });
						}
					} else {
						return;
					}
				});

			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			model.id = id;
			let promises = Array();

			return Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					return PartPurchaseQualityControl.updateData(this, model, id)
						.catch((error) => {
							return this.getPartPurchaseQualityControl(id);
						});
				}
				return false;
			});
		},
		onHidden() {
			this.getPartPurchaseQualityControls();
		},
		addRowDataPartPurchaseQualityControlDetail(modalEvent, model) {
			if (model != null) {
				model.isScanned = true;
				if (model.id != null && model.id != '') {
					model.partPurchaseQualityControlId = this.modelId;
					PartPurchaseQualityControlDetail.updateDataDetail(this, model, model.id)
						.then(result => {
							this.getPartPurchaseQualityControlDetails(true);
							this.isShowPopupPartPurchaseQualityControlDetail = false;
						})
				} else {
					model.partPurchaseQualityControlId = this.modelId;
					PartPurchaseQualityControlDetail.createDataDetail(this, model)
						.then(result => {
							this.getPartPurchaseQualityControlDetails(true);
							this.isShowPopupPartPurchaseQualityControlDetail = false;
						})
				}
			}
		},
		async editRowDataPartPurchaseQualityControlDetail(id) {
			this.partPurchaseQualityControlDetailId = id;
			this.isShowPopupPartPurchaseQualityControlDetail = true;
		},
		async deleteRowDataPartPurchaseQualityControlDetail(id) {
			PartPurchaseQualityControlDetail.deleteData(this, id).then(result => { this.getPartPurchaseQualityControlDetails(); });
		},
		async resetDataPartPurchaseQualityControlDetail() {
			this.partPurchaseQualityControlDetailId = "";
			this.isShowPopupPartPurchaseQualityControlDetail = true;
		},
		async addDataPartPurchaseQualityControlDetail() {
			PartPurchaseQualityControlDetail.createData(this, { partPurchaseQualityControlId: this.modelId })
				.then(result => {
					this.getPartPurchaseQualityControlDetails(true);
				})
		},
		async addFromClipboardPartPurchaseQualityControlDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, partPurchaseQualityControlId: this.modelId });
				});
				PartPurchaseQualityControlDetail.addFromClipboard(this, controlCards).then(result => { this.getPartPurchaseQualityControlDetails() });
			});
		},
		async replaceFromClipboardPartPurchaseQualityControlDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, partPurchaseQualityControlId: this.modelId });
				});
				PartPurchaseQualityControlDetail.replaceFromClipboard(this, controlCards).then(result => { this.getPartPurchaseQualityControlDetails() });
			});
		},
		showPopupUploadPartPurchaseQualityControlDetail() {
			this.isShowPopupUploadPartPurchaseQualityControlDetail = true;
		},
		uploadDataPartPurchaseQualityControlDetail(modalEvent, newDatas) {
			this.isShowPopupUploadPartPurchaseQualityControlDetail = false;
		},
		downloadPartPurchaseQualityControlDetail(modalEvent) {
			this.isDownloadPartPurchaseQualityControlDetail = true;
			this.filterPartPurchaseQualityControlDetail.partPurchaseQualityControlId = this.modelId;
			PartPurchaseQualityControlDetail.downloadDataDetail(this, this.filterPartPurchaseQualityControlDetail).then(result => {
				this.isDownloadPartPurchaseQualityControlDetail = false;
			}).catch(error => { this.isDownloadPartPurchaseQualityControlDetail = false; })
		},
		saveInputPartPurchaseQualityControlDetail(item) {
			if (this.controlCards != null && this.controlCards != undefined && this.controlCards.length > 0) {
				item.controlCard = this.controlCards.find(q => q.id == item.controlCardId);
			}
			if (this.partPurchaseQualityControls != null && this.partPurchaseQualityControls != undefined && this.partPurchaseQualityControls.length > 0) {
				item.partPurchaseQualityControl = this.partPurchaseQualityControls.find(q => q.id == item.partPurchaseQualityControlId);
			}
			if (this.controlCardStatuss != null && this.controlCardStatuss != undefined && this.controlCardStatuss.length > 0) {
				item.controlCardStatus = this.controlCardStatuss.find(q => q.id == item.controlCardStatusId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PartPurchaseQualityControlDetail.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadPartPurchaseQualityControlDetail = false;
			this.isShowPopupPartPurchaseQualityControlDetail = false;
			if (modalType == 'PartPurchaseQualityControlDetail') {
				this.getPartPurchaseQualityControlDetails();
			}
			this.controlCardQrCode = '';
			this.showPopupCopyData = false;
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
			}
		},
		async scanControlCard() {
			this.isScanControlCardLoading = true;
			let qrCode = encodeURIComponent(this.controlCardQrCode);
			let this_ = this;
			delete this_.model.id;

			if (qrCode == undefined || qrCode == null || qrCode == '') {
				this.isScanControlCardLoading = false;
				return;
			}

			//if (qrCode != this_.controlCards[0]) {
				await this_.getControlCardsEqual(qrCode);
				let scanControlCard = this_.controlCards[0];
				if (scanControlCard == undefined || scanControlCard == null) {
					this.isScanControlCardLoading = false;
					return;
				}
			//}else{
			//	await this_.getControlCards(qrCode);
			//	let scanControlCard = this_.controlCards[0];
			//	if (scanControlCard == undefined || scanControlCard == null) {
			//		this.isScanControlCardLoading = false;
			//		return;
			//	}
			//}

			this_.model.controlCard = this_.controlCards[0];
			this_.model.controlCardId = this_.controlCards[0].id;
			this_.model.controlCardControlCardNumber = this_.controlCards[0].controlCardNumber;


			let foundItem = this_.partPurchaseQualityControlDetailsFiltered.find(item => item.controlCardId == this_.controlCards[0].id);
			if (foundItem != null) {
				this.isScanControlCardLoading = false;
				this_.toast({ message: 'Control Card sudah pernah dilakukan QC, silahkan scan Control Card Lainnya', title: 'Message', variant: 'warning', autoHideDelay: 99999 });
				this_.controlCardQrCode = '';
				return;
			}

			let filter = new PartPurchaseQualityControlDetailFilter();
			filter.controlCardId = this_.controlCards[0].id;
			filter.draftMode = "0";
			this_.isScannedControlCard = false;
			await PartPurchaseQualityControlDetail.getList(this_, filter, null, 0, 10)
				.then(result => {
					if (result.data.length > 0) {
						this.isScanControlCardLoading = false;
						this_.toast({ message: 'Control Card sudah pernah dilakukan QC, silahkan scan Control Card Lainnya', title: 'Message', variant: 'warning', autoHideDelay: 99999 });
						this_.isScannedControlCard = true;
						this_.controlCardQrCode = '';
					}
				})
				.catch(error => {
					this.isScanControlCardLoading = false;
				 });

			if (this_.isScannedControlCard) {
				this.isScanControlCardLoading = false;
				return;
			}

			this_.$http.post('PartPurchaseQualityControlDetail/create/', this_.model)
				.then(async function (response) {
					if (response != null) {
						
						let result = response.data;
						this_.goToNext(3, result);
						return;
					}
					this_.toast({ message: 'Failed to process data', title: 'Error', variant: 'danger', autoHideDelay: 99999 });
				})
				.catch(error => {
		
					this_.toast({ message: 'Failed to process data', title: 'Error', variant: 'danger', autoHideDelay: 99999 });
				})
				.finally(() => {
					this.isScanControlCardLoading = false;
				}); 
		},
		checkIsControlCardDisabled(item) {
			// TODO: put your logic here
			return false;
		},
		async goToNext(page, item) {
			if (page == 1) {
				if(item != null && item != undefined){
					this.controlCardQrCode = item.controlCardNumber;
					this.scanControlCard();
				}else {
					this.scanPageIndex = page;
				}
			}

			if (page == 2) {
				await this.updateData();
				await this.getPartPurchaseQualityControlDetails();
				this.scanPageIndex = page;
				return;
			}

			if (page == 3) {
				this.PartPurchaseQualityControlDetailId = item.id;
				this.modelPartPurchaseQualityControlDetail = item;
				this.modelPartPurchaseQualityControlDetail.controlCard = this.controlCards[0];
				this.isShowPopupPartPurchaseQualityControlDetail = true;
				this.isShowInput = false;
				var objPartClassification = this.partClassifications.find(q => q.id == this.model.controlCard.part.partClassificationId);
				if (objPartClassification.code == 'COMPONENT') {
					this.isShowInput = true;
				}
				return;
			}

		},
	},
	beforeMount() {
		this.filterPartPurchaseQualityControl = new PartPurchaseQualityControlFilter();
		this.filterPartPurchaseQualityControlDetail = new PartPurchaseQualityControlDetailFilter();
		//this.getControlCards();
		//this.getPartPurchaseQualityControls();
		//this.getControlCardStatuss();
	},
	async mounted() {
		let this_ = this;
		let id = this_.$route.params.id;
		if (id != '' && id != null && id != undefined) {
			this_.modelId = id;
			await this_.getPartPurchaseQualityControl(id);
		}

		if (this_.model.partPurchaseQualityControlDate != null && this_.model.partPurchaseQualityControlDate != '' && this_.model.partPurchaseQualityControlDate != undefined) {
			this_.goToNext(2);
		}
		await this_.getPartClassification();
		await this_.getControlCards();
		this_.$nextTick(() => {
			this_.focusInput(this_, "fieldset-description");
			this_.getPartPurchaseQualityControlDetails();
			window.addEventListener('resize', this_.displayFilter);
			this_.displayFilter();
		});

	},
	computed: {
	},
	watch: {
		controlCardQrCode(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getControlCards(newValue);
			} else {
				this.getControlCards();
			}
		},
		scanPageIndex() {
			this.hideToast();
		}
	},
}
</script>
